import { Link } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import Button from '../Button'
import styles from './Header.module.css'

function Header() {
  const navigate = useNavigate()

  function logout() {
    if (localStorage) {
      localStorage.removeItem('media')
      navigate('/logga-in')
    }
  }

  return (
    <header className={styles.header}>
      <div className={styles.content}>
        <Link to="/" className={styles.title}>
          Mediabibliotek
        </Link>
        {localStorage && localStorage.getItem('media') && (
          <Button size='small' color='pink' onClick={logout}>Logga ut</Button>
        )}
      </div>
    </header>
  )
}

export default Header
